import { render } from "./align-center.vue?vue&type=template&id=16dd3f83"
const script = {}
script.render = render

export default script